<template>
  <v-container class="webinar-page">
    <section class="webinar-hero">
      <div class="hero-content">
        <p class="eyebrow text-green">Live & On-Demand</p>
        <h1>TeamWaizmann Experten-Webinare</h1>
        <p>
          Wissenstransfer für Zahnärzte, Praxismanager*innen und ZFA: praxisnah, kostenlos und sofort
          umsetzbar. Sichern Sie sich jetzt Ihren Platz.
        </p>
        <div class="hero-actions">
          <v-btn color="primary" class="hero-btn" to="/webinar/8">
            Am nächsten Webinar teilnehmen
          </v-btn>
       
        </div>
      </div>
      <div class="hero-badge">
        <div class="hero-badge__value">{{ webinare.length || '05' }}</div>
        <div class="hero-badge__label">kostenlose Webinare</div>
      </div>
    </section>

    <!-- <section class="webinar-highlights">
      <v-row>
        <v-col cols="12" md="4" v-for="highlight in highlights" :key="highlight.title">
          <div class="highlight-card">
            <v-icon color="primary" size="26">{{ highlight.icon }}</v-icon>
            <h3>{{ highlight.title }}</h3>
            <p>{{ highlight.text }}</p>
          </div>
        </v-col>
      </v-row>
    </section> -->

    <section>
      <v-row>
        <v-col cols="12">
          <div v-if="webinare.length === 0" class="webinar-empty">
            <p>Aktuell sind keine Webinare verfügbar. Schauen Sie bald wieder vorbei.</p>
          </div>
          <div
            v-for="webinar in webinare"
            :key="webinar.wter_id"
            class="webinar-card"
          >
            <WebinarView :showLinkDetails="true" :webinar="webinar" />
          </div>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted } from 'vue'
import WebinarView from '@/components/objects/webinar/WebinarView.vue'


const baseCalls = inject('baseCalls')
const updateDocumentHead = inject('updateDocumentHead');

const webinare = ref([])

// const highlights = [
//   {
//     icon: 'mdi-timer-sand',
//     title: '45 Minuten Fokus',
//     text: 'Kompakte Sessions mit direkten Umsetzungstipps für Ihr Team.',
//   },
//   {
//     icon: 'mdi-monitor-cellphone-star',
//     title: 'Live & OnDemand',
//     text: 'Nehmen Sie live teil oder streamen Sie die Inhalte im Nachgang.',
//   },
//   {
//     icon: 'mdi-account-group',
//     title: 'Für das ganze Team',
//     text: 'Kostenlos für Zahnärzte, Praxismanager*innen und ZFA.',
//   },
// ]

async function getWebinare() {
  let data = {
    action: 'getallwebinare',
    id: 0
  }
  const response = await baseCalls.webinareGet(data)
  if (response.data.webinare) {
    webinare.value = response.data.webinare
  }
}

onMounted(async () => {
  getWebinare()
  updateDocumentHead(
    "TeamWaizmann Experten-Webinare",
    "TeamWaizmann Experten-Webinare"
  )
})
</script>

<style scoped>
.webinar-page {
  max-width: 1080px;
}

.webinar-hero {
  background: linear-gradient(135deg, #e8f5ff, #f6fbff);
  border-radius: 14px;
  padding: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  margin-bottom: 24px;
}

.hero-content {
  flex: 1;
  min-width: 280px;
}

.hero-content h1 {
  margin: 8px 0 12px;
  color: #1f3a63;
}

.hero-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.hero-btn {
  text-transform: none;
  border-radius: 6px;
}

.hero-badge {
  min-width: 160px;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e1e6ef;
  box-shadow: 0 6px 18px rgba(26, 57, 96, 0.08);
}

.hero-badge__value {
  font-size: 42px;
  font-weight: 700;
  color: #3166a5;
}

.hero-badge__label {
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  color: #6b7a99;
}

.webinar-highlights {
  margin-bottom: 24px;
}

.highlight-card {
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(20, 45, 90, 0.05);
}

.highlight-card h3 {
  margin: 12px 0 6px;
  color: #1f3a63;
}

.highlight-card p {
  margin: 0;
  color: #4a5568;
}

.webinar-list .webinar-card {
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 6px 18px rgba(20, 45, 90, 0.05);
}

.webinar-empty {
  border: 1px dashed #cbd4e0;
  border-radius: 10px;
  padding: 24px;
  text-align: center;
  color: #4a5568;
}

.sticky-card {
  position: sticky;
  top: 100px;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.75rem;
  color: #6b7a99;
  margin-bottom: 4px;
}

@media (max-width: 960px) {
  .webinar-hero {
    padding: 24px;
  }
}
</style>